import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  timeout: 30000,
});

// Request interceptor to add auth token and tenant database
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    const selectedTenant = localStorage.getItem('selectedTenant');
    if (selectedTenant) {
      const tenant = JSON.parse(selectedTenant);
      config.headers['X-Tenant-Database'] = tenant.database;
      console.log('API Request with tenant:', tenant.database, 'URL:', config.url);
    } else {
      console.warn('API Request without tenant for URL:', config.url);
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export default api;